<template>
  <div class="cloudShare">
    <div class="line"></div>
    <img src="@/../public/images/loading.png" alt="">
    <div class="zhen_6">{{_lang[$route.query.type].zhen_6}}</div>
  </div>
</template>

<script>
import {lang} from '@/utils/i18n'

export default {
  data(){
    return{
      _lang:[]
    }
  },
  created(){
    this._lang = lang
  }
}
</script>

<style lang='scss' scoped>
.cloudShare{
  width:100%;
  text-align: center;
  margin-top:1.53rem;
  .line{
    height:5px;
    box-shadow: 0 4px 4px #f0f2f4;
  }
  img{
    margin-top:1.47rem;
    width:2.02rem;
  }
  div{
    font-size:0.28rem;
    color:#666666;
    margin-top:0.55rem;
  }
}
</style>
